'use client'

import { Navigate } from 'react-router-dom'
import { getTranslations, useParams, useRouter } from '@/lib/next-shim'
import { ExpertiseDetail } from '@/entities/expertise/ui/ExpertiseDetail'
import { ExpertiseDetailSkeleton } from '@/entities/expertise/ui/ExpertiseDetailSkeleton'
import { useGetMyInfosQuery } from '@/core/graphql/hooks'

export function ExpertisePage() {
  const params = useParams()
  const router = useRouter()
  const expertiseId = params?.id as string
  const t = getTranslations()

  const { data, loading, error } = useGetMyInfosQuery()
  const myInfos = data?.myInfos

  if (loading) {
    return (
      <div className="flex-1 overflow-auto">
        <div className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 lg:px-8">
          <ExpertiseDetailSkeleton />
        </div>
      </div>
    )
  }
  if (error) return <div className="p-10 text-center text-red-500">{t('common.error', { message: error.message })}</div>

  const expertise = myInfos?.expertises.find((item) => item._id === expertiseId)
  if (!expertise) return <Navigate to="/account/expertises" replace />

  return (
    <div className="flex-1 overflow-auto">
      <div className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 lg:px-8">
        <ExpertiseDetail expertise={expertise} submissions={myInfos?.formSubmissions || []} onClose={() => router.push('/account/expertises')} />
      </div>
    </div>
  )
}
